import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/manga';

const categoryKeys = Object.keys(categoryMap);

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20stylized%20illustration%20of%20a%20magical%20library%20with%20floating%20books%20and%20manga%20pages%2C%20soft%20warm%20lighting%20with%20golden%20and%20amber%20tones%2C%20dreamy%20atmosphere%2C%20whimsical%20fantasy%20art%20style%2C%20clean%20aesthetic%2C%20abstract%20background%20with%20soft%20bokeh%20effects%2C%20Japanese%20anime%20inspired%20color%20palette&width=1920&height=800&seq=hero-bg-manga-2026&orientation=landscape"
        alt="香香漫画 - 海量漫画免费阅读"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            海量漫画，<span className="text-primary-400">免费畅读</span>
          </h1>
          <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto leading-relaxed">
            香香漫画网——韩漫、日漫、国漫免费在线阅读平台，下拉式追更体验，好看的漫画免费全集大全，安全直达
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
            <Link
              to="/category/kr"
              className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap"
            >
              开始阅读
            </Link>
            <Link
              to="/category/cn"
              className="px-6 py-2.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
            >
              热门排行
            </Link>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-2 mt-8">
            {categoryKeys.map((key) => (
              <Link
                key={key}
                to={`/category/${key}`}
                className="px-4 py-1.5 bg-white/10 hover:bg-white/20 text-white/90 text-xs font-medium rounded-full backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
              >
                {categoryMap[key]}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}